/**
 * Vendnet – Universal Variant Price Fix
 *
 */

(function () {
  'use strict';

  /* ── Helpers ─── */

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  /**
   * Returns the correct option label for a swatch input.
   
   */
  function getLabelTitle(input) {
    var label = document.querySelector('label[for="' + input.id + '"]');
    return label ? (label.getAttribute('title') || label.innerText.trim()) : null;
  }

  /* ── Selected option readers ─── */

  function getBlockSwatchLabels() {
    var labels = [];
    document.querySelectorAll('.block-swatch input:checked').forEach(function (input) {
      var title = getLabelTitle(input);
      if (title) labels.push(title);
    });
    return labels;
  }

  function getSelectLabels() {
    var labels = [];
    document.querySelectorAll('form.product-form select[name^="option"]').forEach(function (sel) {
      if (sel.value) labels.push(sel.value);
    });
    return labels;
  }

  function getRadioLabels() {
    var labels = [];
    document.querySelectorAll('form.product-form input[type="radio"][name^="option"]:checked').forEach(function (r) {
      if (r.value) labels.push(r.value);
    });
    return labels;
  }

  /** Returns selected labels from whichever selector type is present */
  function getSelectedLabels() {
    var l = getBlockSwatchLabels(); if (l.length) return l;
    l = getSelectLabels();          if (l.length) return l;
    return getRadioLabels();
  }

  /* ── Variant matching ── */

  /** Matches on option1/option2/option3 — works for 1, 2, or 3 options */
  function findMatchingVariant(selectedLabels, variants) {
    return variants.find(function (variant) {
      var options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return (
        options.length === selectedLabels.length &&
        options.every(function (opt) { return selectedLabels.indexOf(opt) !== -1; })
      );
    });
  }

  /* ── DOM updaters ──── */

  function updatePrice(variant) {
    var moneyEl   = document.querySelector('.price-list .money');
    var priceSpan = document.querySelector('.price-list .price');
    if (!moneyEl || !priceSpan) return;

    moneyEl.textContent = formatMoney(variant.price);

    var compareSpan = document.querySelector('.price-list .price--compare');
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (!compareSpan) {
        compareSpan = document.createElement('span');
        compareSpan.className = 'price price--compare';
        compareSpan.innerHTML =
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="money">' + formatMoney(variant.compare_at_price) + '</span>';
        priceSpan.parentNode.insertBefore(compareSpan, priceSpan);
      } else {
        compareSpan.querySelector('.money').textContent = formatMoney(variant.compare_at_price);
      }
      priceSpan.classList.add('price--on-sale');
    } else {
      if (compareSpan) compareSpan.remove();
      priceSpan.classList.remove('price--on-sale');
    }
  }

  function updateVariantInput(variant) {
  var input = document.querySelector('form.product-form input[name="id"]');
  if (!input) return;
  input.value = variant.id;
  if (variant.sku) input.setAttribute('data-sku', variant.sku);
  input.dispatchEvent(new Event('change', { bubbles: true }));

  // Update URL with selected variant ID
  var url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  history.replaceState({}, '', url.toString());
}

  /**
   * Updates the Add to Cart button state.
   *
   * Normal product pages:
   *   - Only updates disabled/enabled based on variant.available
   *   - Never changes display, never overwrites button text
   *
   * Greenlite Pico:
   *   - Also controls visibility based on customer type selection
   *
   * ePort Engage:
   *   - Skipped entirely (applyVariant guards this) — serial gate owns the button
   */
  function updateAddToCartButton(variant) {
    var btn = document.querySelector('#add-to-cart, .product-form__add-button');
    if (!btn) return;

    // Greenlite Pico: customer type controls button visibility
    if (currentHandle === 'greenlite-pico') {
      var checked = document.querySelector('input[name="old"]:checked');
      var isExistingCustomer = checked && checked.id === 'test';
      if (!isExistingCustomer) {
        btn.style.display = 'none';
        return;
      }
      btn.style.display = 'block';
    }

    // All pages: only update disabled state — do NOT change display or textContent
    if (variant && variant.available) {
      btn.removeAttribute('disabled');
    } else if (variant) {
      btn.setAttribute('disabled', 'disabled');
    }
  }

  /** Attach listeners to customer type radios (Greenlite Pico only) */
  function attachCustomerTypeListeners(variants) {
    if (currentHandle !== 'greenlite-pico') return;
    document.querySelectorAll('input[name="old"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var selectedLabels = getSelectedLabels();
        var match = selectedLabels.length ? findMatchingVariant(selectedLabels, variants) : null;
        updateAddToCartButton(match || { available: true });
      });
    });
  }

  /**
   * Mirrors the theme's _updateSelectors logic.
   *
   * Toggles .block-swatch--disabled accordingly.
   */
  function updateSelectors(selectedLabels, variants) {
    document.querySelectorAll('.block-swatch').forEach(function (swatch) {
      var input    = swatch.querySelector('input');
      if (!input) return;

      var position = parseInt(input.getAttribute('data-option-position'), 10);
      var value    = getLabelTitle(input);
      if (!value || !position) return;

      var available = false;

      if (position === 1) {
        available = variants.some(function (v) {
          return v.option1 === value && v.available;
        });
      } else if (position === 2) {
        available = variants.some(function (v) {
          return v.option2 === value &&
                 v.option1 === selectedLabels[0] &&
                 v.available;
        });
      } else if (position === 3) {
        available = variants.some(function (v) {
          return v.option3 === value &&
                 v.option1 === selectedLabels[0] &&
                 v.option2 === selectedLabels[1] &&
                 v.available;
        });
      }

      swatch.classList.toggle('block-swatch--disabled', !available);
    });
  }

  /* ── Core ── */

  // Holds the current page handle — set in init(), used to scope page-specific logic
  var currentHandle = '';

  function applyVariant(variants) {
    var selectedLabels = getSelectedLabels();
    if (!selectedLabels.length) return;

    var match = findMatchingVariant(selectedLabels, variants);

    // Always update selector states (availability) even if no exact match
    updateSelectors(selectedLabels, variants);

    if (!match) return;

    updatePrice(match);
    updateVariantInput(match);

    // ePort Engage: Add to Cart visibility/disabled state is controlled exclusively
    // by the serial gate (initEngageSerialGate). Don't touch it here.
    if (currentHandle !== 'eport-engage') {
      updateAddToCartButton(match);
    }
  }

  function attachListeners(variants) {
    document.querySelectorAll('.block-swatch input').forEach(function (input) {
      input.addEventListener('change', function () { applyVariant(variants); });
    });
    document.querySelectorAll('form.product-form select[name^="option"]').forEach(function (sel) {
      sel.addEventListener('change', function () { applyVariant(variants); });
    });
    document.querySelectorAll('form.product-form input[type="radio"][name^="option"]').forEach(function (r) {
      r.addEventListener('change', function () { applyVariant(variants); });
    });
  }

  /* ── ePort Engage: 6-digit serial gate ── */

  /**
   * ePort Engage page only (handle = "eport-engage").
   *
   * Behaviour:
   *   - Add to Cart is visible but disabled on page load
   *   - Listens to the existing input#numberinput field
   *   - Enables Add to Cart only when exactly 6 numeric digits are entered
   *   - Disables Add to Cart again if digits drop below 6
   */
  function initEngageSerialGate(handle) {
    if (handle !== 'eport-engage') return;

    var btn         = document.querySelector('#add-to-cart, .product-form__add-button');
    var serialInput = document.querySelector('#numberinput, [name="customerid"]');

    if (!btn || !serialInput) return;

    // Visible but disabled on page load
    btn.style.display = 'block';
    btn.setAttribute('disabled', 'disabled');

    serialInput.addEventListener('input', function () {
      // Strip non-digits to enforce numeric-only
      var digits = this.value.replace(/\D/g, '');
      if (this.value !== digits) this.value = digits;

      if (digits.length === 6) {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
      }
    });
  }

  /* ── Init ─── */

  function init() {
    var hasSwatches = document.querySelectorAll('.block-swatch input').length > 0;
    var hasSelects  = document.querySelectorAll('form.product-form select[name^="option"]').length > 0;
    var hasRadios   = document.querySelectorAll('form.product-form input[type="radio"][name^="option"]').length > 0;

    if (!hasSwatches && !hasSelects && !hasRadios) return;

    var meta   = window.ShopifyAnalytics &&
                 window.ShopifyAnalytics.meta &&
                 window.ShopifyAnalytics.meta.product;

    var handle = (meta && meta.handle) ||
                 (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];

    if (!handle) return;

    currentHandle = handle; // Make handle available to all scoped functions

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variants = product.variants;
        if (!variants || !variants.length) return;

        applyVariant(variants);              // Set correct state on page load
        attachListeners(variants);           // Keep in sync on variant swatch changes
        attachCustomerTypeListeners(variants); // Show/hide cart on customer type change (Greenlite Pico)
        initEngageSerialGate(handle);        // 6-digit serial gate (ePort Engage)
      })
      .catch(function (err) {
        console.warn('[VariantFix] Could not load product data:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();